import { useState, useEffect } from "react";

/**
 * Detects whether the Duneworks Chrome extension is installed using a
 * custom-event handshake.
 *
 * The extension's content script listens for "DUNEWORKS_EXT_PING" on
 * `document` and responds with "DUNEWORKS_EXT_PONG".  If a pong arrives
 * within a short timeout the hook returns `true`.
 */
export function useExtensionDetected(): boolean {
  const [installed, setInstalled] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const onPong = () => {
      if (!cancelled) setInstalled(true);
    };

    document.addEventListener("DUNEWORKS_EXT_PONG", onPong);

    // Fire the ping — if the content script is loaded it will answer immediately.
    document.dispatchEvent(new CustomEvent("DUNEWORKS_EXT_PING"));

    // Also retry once after a short delay in case the content script
    // hasn't initialised yet (e.g. slow page load).
    const retryTimer = setTimeout(() => {
      document.dispatchEvent(new CustomEvent("DUNEWORKS_EXT_PING"));
    }, 500);

    return () => {
      cancelled = true;
      clearTimeout(retryTimer);
      document.removeEventListener("DUNEWORKS_EXT_PONG", onPong);
    };
  }, []);

  return installed;
}
